import styled from 'styled-components';
import { DeleteButton } from './DeleteAccount.styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: black;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid #404040;
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #404040;
`;

export const ModalTitle = styled.h2`
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  font-family: inherit;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #404040;
    color: #ffffff;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;

  ul {
    margin: 16px 0;
    padding-left: 20px;

    li {
      color: #cccccc;
      margin-bottom: 8px;
      line-height: 1.5;
    }
  }
`;

export const ModalDescription = styled.p`
  color: #cccccc;
  margin: 0 0 16px 0;
  line-height: 1.6;
  font-size: 14px;
  text-align: center;
`;

export const UserName = styled.strong`
  color: #ffffff;
  text-transform: capitalize;
`;

export const ModalImage = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 20em;
  padding: 1em;
`;

export const ModalInfo = styled.div`
  color: #cccccc;
  margin: 0 0 16px 0;
  line-height: 1.1;
  font-size: 14px;
  text-align: center;

  .warning {
    color: #ffcc00;
  }
`;

export const ModalWarning = styled.div`
  background: linear-gradient(135deg, #ff4444 0%, #cc0000 100%);
  color: #ffffff;
  padding: 16px;
  border-radius: 12px;
  margin: 16px 0;
  border: 1px solid #ff6666;

  strong {
    font-weight: 600;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 16px;
  padding: 0 24px 24px 24px;
  justify-content: flex-end;
`;

export const ConfirmButton = styled(DeleteButton)`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  height: 42px;
  width: fit-content;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 68, 68, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CancelButton = styled.button`
  background: transparent;
  color: #888;
  border: 1px solid #404040;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;

  &:hover {
    background-color: #404040;
    color: #ffffff;
    border-color: #555;
  }
`;

export const ErrorMessage = styled.p`
  color: #ed1616;
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
`;
